(function() {
  const CDN = 'https://cdn.shopify.com/s/files/1/0638/1725/3114/files/';

  const PRICES_USD = { small: '$900', medium: '$1,500', large: '$2,700' };
  const PRICES_EUR = { small: '€900', medium: '€1,500', large: '€2,700' };
  let currency = 'USD';
  function PRICES(size) { return currency === 'EUR' ? PRICES_EUR[size] : PRICES_USD[size]; }

  function generateBundleId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  const SWATCH_COLORS = {
    light: '#d08e32', water: '#5c848e', bloom: '#5c4c87',
    endless: '#b82b35', psyche: '#5a2540', reflections: '#353d75',
    feathers: '#67ac33', python: '#907e71', fur: '#948c84', gold: '#ceb04e'
  };

  const SCENT_NOTES = {
    light:       { mood: 'Warm, sunny, optimistic',        top: 'Bergamot, lemon, neroli',                     heart: 'Grapefruit, petitgrain',               base: 'Fig, white musk' },
    water:       { mood: 'Fresh, bright, Mediterranean',   top: 'Lemon, bergamot',                             heart: 'Orange, grapefruit',                   base: 'Norlimbanol, soft musk' },
    bloom:       { mood: 'Dewy, floral, luminous',         top: 'Freesia accord',                              heart: 'Moss, cashmeran, hedione',             base: 'Musk, vanilla' },
    endless:     { mood: 'Passionate, juicy, bold',        top: 'Blackcurrant, raspberry, calone',             heart: 'Hedione, intense wood',                base: 'Musk, sandalwood' },
    reflections: { mood: 'Green, calming, grounding',      top: 'Verbena, bergamot',                           heart: 'Lemongrass, hedione',                  base: 'Musk, patchouli, habanolide' },
    psyche:      { mood: 'Floral, tender, sensual',        top: 'Petitgrain, bergamot',                        heart: 'Rose, peony, hedione, geranium',       base: 'Musk, styrax, vanilla' },
    feathers:    { mood: 'Serene, meditative, airy',       top: 'Calone, bergamot',                            heart: 'White tea, neroli, guaiac wood, moss', base: 'Musk, sandalwood' },
    python:      { mood: 'Ethereal, poetic, dreamy',       top: 'Wisteria accord',                             heart: 'Gardenia, norlimbanol woods',          base: 'Ylang-ylang, vanilla' },
    fur:         { mood: 'Pure, luminous, refined',        top: 'Rose, white accords, bergamot, blackcurrant', heart: 'Hedione',                              base: 'Musk, romandolide' },
    gold:        { mood: 'Delicate, powerful, dawn-like',  top: 'Peony accord, cetalox',                       heart: 'Hedione, cassione',                    base: 'Musk, patchouli' }
  };

  let state = { size: 'medium', position: 'top', top: 'light', mid: 'light', bottom: 'light' };
  let basket = [];
  const PRICE_NUMS_USD = { small: 900, medium: 1500, large: 2700 };
  const PRICE_NUMS_EUR = { small: 900, medium: 1500, large: 2700 };
  function PRICE_NUMS(size) { return currency === 'EUR' ? PRICE_NUMS_EUR[size] : PRICE_NUMS_USD[size]; }

  const imgShadow = document.getElementById('img-shadow');
  const imgBottom = document.getElementById('img-bottom');
  const imgMid    = document.getElementById('img-mid');
  const imgTop    = document.getElementById('img-top');
  const sizeBadge = document.getElementById('col-size-badge');
  const priceEl   = document.getElementById('col-price');
  const btnMid    = document.getElementById('btn-mid');
  const sumMidRow = document.getElementById('sum-mid-row');
  const fsMidRow  = document.getElementById('fs-mid-row');

  // ── ZONE MAP ───────────────────────────────────────────────────────────────
  const zoneCanvas      = document.createElement('canvas');
  const zoneCtx         = zoneCanvas.getContext('2d');
  const zoneCanvasSmall = document.createElement('canvas');
  const zoneCtxSmall    = zoneCanvasSmall.getContext('2d');

  function loadZoneMap(img, canvas, ctx, url) {
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      canvas.width  = img.naturalWidth;
      canvas.height = img.naturalHeight;
      ctx.drawImage(img, 0, 0);
    };
    img.src = url;
  }

  const zoneImg      = new Image();
  const zoneImgSmall = new Image();
  loadZoneMap(zoneImg,      zoneCanvas,      zoneCtx,      CDN + 'col-zone-map.png');
  loadZoneMap(zoneImgSmall, zoneCanvasSmall, zoneCtxSmall, CDN + 'col-zone-map-small.png');

  function sampleZone(e, canvasEl) {
    const rect   = canvasEl.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const isSmall   = state.size === 'small';
    const activeCtx = isSmall ? zoneCtxSmall : zoneCtx;
    const activeMap = isSmall ? zoneCanvasSmall : zoneCanvas;
    if (activeMap.width === 0) return null;
    const mapX = Math.floor((clickX / rect.width)  * activeMap.width);
    const mapY = Math.floor((clickY / rect.height) * activeMap.height);
    let pixel;
    try { pixel = activeCtx.getImageData(mapX, mapY, 1, 1).data; }
    catch(err) { return null; }
    const r = pixel[0], g = pixel[1], b = pixel[2], a = pixel[3];
    if (a < 50) return null;
    if (r > 200 && g > 200 && b > 200) return null;
    if (r > 150 && g < 100 && b < 100) return 'top';
    if (b > 150 && r < 100 && g < 100) return 'mid';
    if (g > 150 && r < 100 && b < 100) return 'bottom';
    return null;
  }

  const canvasEl    = document.getElementById('col-canvas');
  const cursorEl    = document.getElementById('col-cursor');
  const cursorLabel = document.getElementById('col-cursor-label');
  const cursorCircle = document.getElementById('col-cursor-circle');
  const ZONE_LABELS = { top: 'Select Top', mid: 'Select Middle', bottom: 'Select Bottom' };

  canvasEl.addEventListener('contextmenu', function(e) { e.preventDefault(); });

  canvasEl.addEventListener('click', function(e) {
    const zone = sampleZone(e, this);
    if (!zone) return;
    if (zone === 'mid' && state.size === 'small') return;
    state.position = zone;
    setPosBtnActive(zone);
    updateSwatchActive();
  });

  canvasEl.addEventListener('mousemove', function(e) {
    cursorEl.style.display = 'flex';
    cursorEl.style.left = e.clientX + 'px';
    cursorEl.style.top  = e.clientY + 'px';
    const zone = sampleZone(e, this);
    if (zone && !(zone === 'mid' && state.size === 'small')) {
      cursorLabel.textContent = ZONE_LABELS[zone];
      const zoneCollection = zone === 'top' ? state.top : zone === 'mid' ? state.mid : state.bottom;
      cursorCircle.style.background = SWATCH_COLORS[zoneCollection] || '#3a2419';
      cursorEl.style.opacity  = '1';
    } else {
      cursorEl.style.opacity  = '0';
    }
  });

  canvasEl.addEventListener('mouseleave', function() {
    cursorEl.style.display = 'none';
  });
  // ── END ZONE MAP ───────────────────────────────────────────────────────────

  function imgUrl(collection, layer, isSmall) {
    return `${CDN}${collection}-${layer}${isSmall ? '-small' : ''}.png`;
  }

  async function captureCandle() {
    const sm = state.size === 'small';
    const urls = [
      `${CDN}bottom-shadow${sm ? '-small' : ''}.png`,
      imgUrl(state.bottom, 'bottom', sm),
      ...(!sm ? [imgUrl(state.mid, 'mid', false)] : []),
      imgUrl(state.top, 'top', sm)
    ];
    try {
      const images = await Promise.all(urls.map(url => new Promise((res, rej) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload  = () => res(img);
        img.onerror = () => rej(new Error('Failed: ' + url));
        img.src = url;
      })));
      const canvas = document.createElement('canvas');
      canvas.width = 560; canvas.height = 560;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, 560, 560);
      images.forEach(img => ctx.drawImage(img, 0, 0, 560, 560));
      return canvas.toDataURL('image/jpeg', 0.85).split(',')[1];
    } catch (e) {
      console.warn('Candle capture failed (non-fatal):', e);
      return null;
    }
  }

  function renderCandlePreview(candle) {
    const sm = candle.size === 'small';
    const wrap = document.createElement('div');
    wrap.className = 'col-basket-preview';
    function img(src) {
      const el = document.createElement('img');
      el.src = src; el.alt = ''; el.draggable = false;
      return el;
    }
    wrap.appendChild(img(`${CDN}bottom-shadow${sm ? '-small' : ''}.png`));
    wrap.appendChild(img(imgUrl(candle.bottom, 'bottom', sm)));
    if (!sm) wrap.appendChild(img(imgUrl(candle.mid, 'mid', false)));
    wrap.appendChild(img(imgUrl(candle.top, 'top', sm)));
    return wrap;
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function updateCanvas() {
    const sm = state.size === 'small';
    const canvas = document.getElementById('col-canvas');

    // Update data-size so CSS media queries pick the right fixed size
    canvas.dataset.size = state.size;
    document.querySelector('.col-stage').dataset.size = state.size;

    // JS sets the default size; CSS media queries override at smaller screens
    const canvasSize = state.size === 'large' ? '800px' : state.size === 'medium' ? '600px' : '560px';
    canvas.style.width  = canvasSize;
    canvas.style.height = canvasSize;

    imgShadow.src = `${CDN}bottom-shadow${sm ? '-small' : ''}.png`;
    imgBottom.src = imgUrl(state.bottom, 'bottom', sm);
    imgTop.src    = imgUrl(state.top, 'top', sm);

    if (sm) {
      imgMid.src = '';
      imgMid.classList.add('hidden');
    } else {
      imgMid.src = imgUrl(state.mid, 'mid', false);
      imgMid.classList.remove('hidden');
    }

    sizeBadge.textContent = capitalize(state.size);
    priceEl.textContent   = PRICES(state.size) || '—';
    const mobilePriceEl = document.getElementById('col-price-mobile');
    if (mobilePriceEl) mobilePriceEl.textContent = PRICES(state.size) || '—';
  }

  function setNotes(prefix, collection) {
    const n = SCENT_NOTES[collection] || {};
    const el = id => document.getElementById(id);
    if (el(prefix+'-mood'))       el(prefix+'-mood').textContent       = n.mood  || '';
    if (el(prefix+'-top-note'))   el(prefix+'-top-note').textContent   = n.top   ? 'Top: '   + n.top   : '';
    if (el(prefix+'-heart-note')) el(prefix+'-heart-note').textContent = n.heart ? 'Heart: ' + n.heart : '';
    if (el(prefix+'-base-note'))  el(prefix+'-base-note').textContent  = n.base  ? 'Base: '  + n.base  : '';
  }

  function updateSummary() {
    const showMid = state.size !== 'small';
    const { top, mid, bottom } = state;
    const el = id => document.getElementById(id);

    // Reset all rows visible, then selectively hide duplicates
    el('sum-bottom-row').style.display = '';
    sumMidRow.style.display = showMid ? '' : 'none';

    if (showMid) {
      if (top === mid && mid === bottom) {
        el('sum-top-key').textContent = 'All Layers';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        sumMidRow.style.display = 'none';
        el('sum-bottom-row').style.display = 'none';
      } else if (top === mid) {
        el('sum-top-key').textContent = 'Top & Middle';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        sumMidRow.style.display = 'none';
        el('sum-bottom-key').textContent = 'Bottom';
        el('sum-bottom').textContent = capitalize(bottom);
        setNotes('sum-bottom', bottom);
      } else if (mid === bottom) {
        el('sum-top-key').textContent = 'Top';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        el('sum-mid-key').textContent = 'Middle & Bottom';
        el('sum-mid').textContent = capitalize(mid);
        setNotes('sum-mid', mid);
        el('sum-bottom-row').style.display = 'none';
      } else {
        el('sum-top-key').textContent = 'Top';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        el('sum-mid-key').textContent = 'Middle';
        el('sum-mid').textContent = capitalize(mid);
        setNotes('sum-mid', mid);
        el('sum-bottom-key').textContent = 'Bottom';
        el('sum-bottom').textContent = capitalize(bottom);
        setNotes('sum-bottom', bottom);
      }
    } else {
      // Small candle — 2 layers
      if (top === bottom) {
        el('sum-top-key').textContent = 'Top & Bottom';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        el('sum-bottom-row').style.display = 'none';
      } else {
        el('sum-top-key').textContent = 'Top';
        el('sum-top').textContent = capitalize(top);
        setNotes('sum-top', top);
        el('sum-bottom-key').textContent = 'Bottom';
        el('sum-bottom').textContent = capitalize(bottom);
        setNotes('sum-bottom', bottom);
      }
    }

    document.getElementById('fs-size').textContent   = capitalize(state.size);
    document.getElementById('fs-top').textContent    = capitalize(state.top);
    document.getElementById('fs-mid').textContent    = capitalize(state.mid);
    document.getElementById('fs-bottom').textContent = capitalize(state.bottom);
    fsMidRow.style.display = showMid ? '' : 'none';
  }

  function updateSwatchActive() {
    const current = state.position === 'mid' ? state.mid :
                    state.position === 'top' ? state.top : state.bottom;
    document.querySelectorAll('.col-swatch-item').forEach(el => {
      el.classList.toggle('active', el.dataset.collection === current);
    });
  }

  function setPosBtnActive(pos) {
    document.querySelectorAll('.col-pos-btn').forEach(b => {
      b.classList.remove('active');
      b.style.color = '';
    });
    const target = document.querySelector(`.col-pos-btn[data-pos="${pos}"]`);
    if (target) {
      target.classList.add('active');
      target.style.color = '#FFFFFF';
    }
  }

  function refresh() {
    updateCanvas();
    updateSummary();
    updateSwatchActive();
  }

  document.querySelectorAll('.col-pill').forEach(btn => {
    btn.addEventListener('click', () => {
      state.size = btn.dataset.size;
      document.querySelectorAll('.col-pill').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (state.size === 'small') {
        btnMid.disabled = true;
        if (state.position === 'mid') {
          state.position = 'top';
          setPosBtnActive('top');
        }
      } else {
        btnMid.disabled = false;
      }
      refresh();
    });
  });

  document.querySelectorAll('.col-pos-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      state.position = btn.dataset.pos;
      setPosBtnActive(btn.dataset.pos);
      updateSwatchActive();
    });
  });

  // Inject mood text into swatches for hover display
  document.querySelectorAll('.col-swatch-item').forEach(el => {
    const mood = (SCENT_NOTES[el.dataset.collection] || {}).mood;
    if (mood) {
      const moodEl = document.createElement('span');
      moodEl.className = 'col-swatch-mood';
      moodEl.textContent = mood;
      el.appendChild(moodEl);
    }
  });

  document.querySelectorAll('.col-swatch-item').forEach(el => {
    el.addEventListener('click', () => {
      const col = el.dataset.collection;
      if      (state.position === 'top') state.top    = col;
      else if (state.position === 'mid') state.mid    = col;
      else                               state.bottom = col;
      refresh();
    });
  });

  document.getElementById('btn-reset').addEventListener('click', () => {
    state = { size: 'medium', position: 'top', top: 'light', mid: 'light', bottom: 'light' };
    document.querySelectorAll('.col-pill').forEach(b => b.classList.toggle('active', b.dataset.size === 'medium'));
    setPosBtnActive('top');
    btnMid.disabled = false;
    refresh();
  });

  const overlay    = document.getElementById('col-overlay');
  const formFields = document.getElementById('col-form-fields');
  const successEl  = document.getElementById('col-success');

  function openOverlay() {
    updateSummary();
    formFields.classList.remove('hidden');
    successEl.classList.remove('visible');
    overlay.classList.add('open');
  }

  function closeOverlay() { overlay.classList.remove('open'); }

  function openDrawer() {
    document.getElementById('col-drawer').classList.add('open');
    document.getElementById('col-drawer-backdrop').classList.add('open');
  }

  function closeDrawer() {
    document.getElementById('col-drawer').classList.remove('open');
    document.getElementById('col-drawer-backdrop').classList.remove('open');
    resetDrawerPhase();
  }

  function setFormMode(on) {
    const drawer = document.getElementById('col-drawer');
    drawer.classList.toggle('form-mode', on);
    if (!on) drawer.classList.remove('expanded');
  }

  function resetDrawerPhase() {
    document.getElementById('col-drawer-summary').style.display = '';
    document.getElementById('col-drawer-form').classList.remove('visible');
    document.getElementById('col-drawer-success').classList.remove('visible');
    setFormMode(false);
    ['inp-first','inp-last','inp-email','inp-phone','inp-address','inp-city','inp-zip','inp-country'].forEach(id => {
      document.getElementById(id).value = '';
    });
    const placeBtn = document.getElementById('btn-place-order');
    placeBtn.disabled = false;
    placeBtn.textContent = 'Place Order';
  }

  function updateQty(id, newQty) {
    const item = basket.find(c => c.id === id);
    if (!item) return;
    item.qty = Math.max(1, Math.floor(newQty));
    renderDrawer();
  }

  function renderDrawer() {
    const body      = document.getElementById('col-drawer-body');
    const totalEl   = document.getElementById('col-drawer-total');
    const submitBtn = document.getElementById('btn-drawer-submit');
    body.innerHTML = '';
    const fab = document.getElementById('col-cart-fab');
    const fabCount = document.getElementById('col-cart-fab-count');
    if (fab && fabCount) {
      fabCount.textContent = basket.length;
      fab.classList.toggle('visible', basket.length > 0);
    }
    if (basket.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'col-drawer-empty';
      empty.textContent = 'Your basket is empty';
      body.appendChild(empty);
      totalEl.textContent = '—';
      submitBtn.disabled = true;
      return;
    }
    submitBtn.disabled = false;

    const totalCandles = basket.reduce((s, c) => s + c.qty, 0);
    const totalAmt = basket.reduce((sum, c) => sum + (PRICE_NUMS(c.size) || 0) * c.qty, 0);
    const symbol = currency === 'EUR' ? '€' : '$';
    const totalText = symbol + totalAmt.toLocaleString('en-US');
    const collapsed = document.createElement('button');
    collapsed.type = 'button';
    collapsed.className = 'col-drawer-collapsed';
    const drawerEl = document.getElementById('col-drawer');
    collapsed.setAttribute('aria-expanded', drawerEl.classList.contains('expanded') ? 'true' : 'false');
    collapsed.setAttribute('aria-label', 'Show order details');
    const itemLabel = `${totalCandles} ${totalCandles === 1 ? 'candle' : 'candles'}`;
    collapsed.innerHTML = `<span class="col-drawer-collapsed-text">${itemLabel}<span class="col-drawer-collapsed-total">${totalText}</span></span><span class="col-drawer-collapsed-chevron" aria-hidden="true">▾</span>`;
    collapsed.addEventListener('click', () => {
      const drawer = document.getElementById('col-drawer');
      const expanded = drawer.classList.toggle('expanded');
      collapsed.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    body.appendChild(collapsed);

    basket.forEach(candle => {
      const item = document.createElement('div');
      item.className = 'col-basket-item';
      item.appendChild(renderCandlePreview(candle));
      const info = document.createElement('div');
      info.className = 'col-basket-info';
      const sizeEl = document.createElement('p');
      sizeEl.className = 'col-basket-size';
      sizeEl.textContent = capitalize(candle.size);
      info.appendChild(sizeEl);
      const layers = candle.size === 'small'
        ? [['Top', candle.top], ['Bottom', candle.bottom]]
        : [['Top', candle.top], ['Mid', candle.mid], ['Bottom', candle.bottom]];
      layers.forEach(([key, val]) => {
        const row = document.createElement('div');
        row.className = 'col-basket-layer-row';
        row.innerHTML = `<span class="col-basket-layer-key">${key}</span><span class="col-basket-layer-val">${capitalize(val)}</span>`;
        info.appendChild(row);
      });
      const qtyRow = document.createElement('div');
      qtyRow.className = 'col-basket-qty-row';
      const minusBtn = document.createElement('button');
      minusBtn.className = 'col-basket-qty-btn';
      minusBtn.textContent = '−';
      minusBtn.setAttribute('aria-label', 'Decrease quantity');
      minusBtn.addEventListener('click', () => updateQty(candle.id, candle.qty - 1));
      const qtyInput = document.createElement('input');
      qtyInput.type = 'number';
      qtyInput.min = '1'; qtyInput.max = '99';
      qtyInput.value = candle.qty;
      qtyInput.className = 'col-basket-qty-input';
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value, 10);
        if (!isNaN(val) && val >= 1) updateQty(candle.id, val);
        else qtyInput.value = candle.qty;
      });
      const plusBtn = document.createElement('button');
      plusBtn.className = 'col-basket-qty-btn';
      plusBtn.textContent = '+';
      plusBtn.setAttribute('aria-label', 'Increase quantity');
      plusBtn.addEventListener('click', () => updateQty(candle.id, candle.qty + 1));
      qtyRow.append(minusBtn, qtyInput, plusBtn);
      info.appendChild(qtyRow);
      const priceEl = document.createElement('p');
      priceEl.className = 'col-basket-price';
      priceEl.textContent = candle.price;
      info.appendChild(priceEl);
      item.appendChild(info);
      const removeBtn = document.createElement('button');
      removeBtn.className = 'col-basket-remove';
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.textContent = '✕';
      removeBtn.addEventListener('click', () => removeFromBasket(candle.id));
      item.appendChild(removeBtn);
      body.appendChild(item);
    });
    totalEl.textContent = totalText;
  }

  function makeFallbackSVG(candle) {
    const layers = candle.size === 'small' ? ['top', 'bottom'] : ['top', 'mid', 'bottom'];
    const s = 200, bandH = s / layers.length;
    const rects = layers.map((layer, i) =>
      `<rect x="0" y="${(i * bandH).toFixed(2)}" width="${s}" height="${bandH.toFixed(2)}" fill="${SWATCH_COLORS[candle[layer]] || '#ccc'}"/>`
    ).join('');
    const sep = layers.slice(1).map((_, i) =>
      `<line x1="0" y1="${((i + 1) * bandH).toFixed(2)}" x2="${s}" y2="${((i + 1) * bandH).toFixed(2)}" stroke="#fff" stroke-width="1.5"/>`
    ).join('');
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}"><defs><clipPath id="fb"><circle cx="100" cy="100" r="95"/></clipPath></defs><g clip-path="url(#fb)">${rects}${sep}</g></svg>`;
    return btoa(svg);
  }

  async function addToBasket() {
    const imageBase64 = await captureCandle();
    basket.push({
      id: generateBundleId(),
      size: state.size, top: state.top, mid: state.mid, bottom: state.bottom,
      price: PRICES(state.size),
      qty: 1,
      imageBase64
    });
    renderDrawer();
    resetDrawerPhase();
    closeOverlay();
    openDrawer();
  }

  function removeFromBasket(id) {
    basket = basket.filter(c => c.id !== id);
    renderDrawer();
  }

  async function submitOrder() {
    const firstName = document.getElementById('inp-first').value.trim();
    const lastName  = document.getElementById('inp-last').value.trim();
    const email     = document.getElementById('inp-email').value.trim();
    const phoneCode = document.getElementById('inp-phone-code').value;
    const phoneNum  = document.getElementById('inp-phone').value.trim().replace(/[\s\-\(\)\.]/g, '');
    const phone     = phoneCode + phoneNum;
    const address   = document.getElementById('inp-address').value.trim();
    const city      = document.getElementById('inp-city').value.trim();
    const state     = document.getElementById('inp-state').value.trim();
    const zip       = document.getElementById('inp-zip').value.trim();
    const country   = document.getElementById('inp-country').value;
    if (!firstName || !lastName || !email) { alert('Please fill in your first name, last name, and email.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { alert('Please enter a valid email address.'); return; }
    const placeBtn = document.getElementById('btn-place-order');
    placeBtn.disabled = true;
    placeBtn.textContent = 'Placing Order…';
    try {
      const res = await fetch('https://jocular-dango-6e689a.netlify.app/.netlify/functions/create-draft-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer: { firstName, lastName, email, phone, address, city, state, zip, country },
          currency,
          candles: basket.map(c => ({ id: c.id, size: c.size, top: c.top, mid: c.mid, bottom: c.bottom, qty: c.qty, imageBase64: c.imageBase64 || null, fallbackSVG: c.imageBase64 ? null : makeFallbackSVG(c) }))
        })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || `Server error ${res.status}`);
      }
      basket = [];
      renderDrawer();
      document.getElementById('col-drawer-summary').style.display = 'none';
      document.getElementById('col-drawer-form').classList.remove('visible');
      document.getElementById('col-drawer-success').classList.add('visible');
      setFormMode(false);
    } catch (err) {
      console.error('Order error:', err);
      alert('Could not place order: ' + err.message + '\nPlease try again.');
      placeBtn.disabled = false;
      placeBtn.textContent = 'Place Order';
    }
  }

  document.getElementById('btn-preorder').addEventListener('click', openOverlay);
  document.getElementById('btn-close').addEventListener('click', closeOverlay);
  document.getElementById('btn-cancel').addEventListener('click', closeOverlay);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeOverlay(); });

  document.getElementById('btn-submit').addEventListener('click', addToBasket);

  document.getElementById('btn-drawer-close').addEventListener('click', closeDrawer);
  document.getElementById('col-drawer-backdrop').addEventListener('click', closeDrawer);
  document.getElementById('col-cart-fab').addEventListener('click', openDrawer);
  document.getElementById('btn-drawer-submit').addEventListener('click', () => {
    if (basket.length === 0) return;
    document.getElementById('col-drawer-summary').style.display = 'none';
    document.getElementById('col-drawer-form').classList.add('visible');
    setFormMode(true);
  });
  document.getElementById('btn-drawer-back').addEventListener('click', () => {
    document.getElementById('col-drawer-form').classList.remove('visible');
    document.getElementById('col-drawer-summary').style.display = '';
    setFormMode(false);
  });
  document.getElementById('btn-place-order').addEventListener('click', submitOrder);

  // Currency: auto-switch based on shipping country
  function setCurrency(newCurrency) {
    if (newCurrency === currency) return;
    currency = newCurrency;
    const showVat = currency === 'EUR';
    document.querySelectorAll('.col-vat-note').forEach(el => el.style.display = showVat ? '' : 'none');
    refresh();
    basket.forEach(c => { c.price = PRICES(c.size); });
    renderDrawer();
  }
  const EU_COUNTRIES = ['Italy','France','Germany','Spain','Netherlands','Belgium','Austria','Portugal','Poland','Greece','Ireland','Finland'];
  const COUNTRY_TO_PHONE = {
    'United States': '+1',  'United Kingdom': '+44', 'France': '+33',
    'Germany': '+49',       'Italy': '+39',          'Spain': '+34',
    'Switzerland': '+41',   'Netherlands': '+31',    'Sweden': '+46',
    'Norway': '+47',        'Denmark': '+45',        'Belgium': '+32',
    'Austria': '+43',       'Portugal': '+351',      'Poland': '+48',
    'Greece': '+30',        'Ireland': '+353',       'Finland': '+358'
  };
  document.getElementById('inp-country').addEventListener('change', function() {
    setCurrency(EU_COUNTRIES.includes(this.value) ? 'EUR' : 'USD');
    if (this.value !== 'Other' && COUNTRY_TO_PHONE[this.value]) {
      document.getElementById('inp-phone-code').value = COUNTRY_TO_PHONE[this.value];
    }
  });

  function preloadDefault() {
    ['light-top.png','light-mid.png','light-bottom.png','bottom-shadow.png'].forEach(name => {
      const img = new Image(); img.src = CDN + name;
    });
  }

  function preloadAll() {
    const collections = ['light','water','bloom','endless','psyche','reflections','feathers','python','fur','gold'];
    const layers      = ['top','mid','bottom','top-small','bottom-small'];
    collections.forEach(col => {
      layers.forEach(layer => { const img = new Image(); img.src = `${CDN}${col}-${layer}.png`; });
    });
    ['bottom-shadow.png','bottom-shadow-small.png'].forEach(name => {
      const img = new Image(); img.src = CDN + name;
    });
  }

  preloadDefault();
  if ('requestIdleCallback' in window) { requestIdleCallback(preloadAll); }
  else { setTimeout(preloadAll, 2000); }

  refresh();

  // ── STAGE SCROLL BEHAVIOUR ────────────────────────────────────────────────
  const stageEl = document.querySelector('.col-stage');
  const configuratorEl = document.getElementById('col-configurator');

  function updateStageScroll() {
    if (window.innerWidth <= 900) { stageEl.style.transform = ''; return; }
    const overshoot = Math.max(0, window.innerHeight - configuratorEl.getBoundingClientRect().bottom);
    stageEl.style.transform = overshoot > 0 ? `translateY(-${overshoot}px)` : '';
  }

  window.addEventListener('scroll', updateStageScroll, { passive: true });
  window.addEventListener('resize', updateStageScroll);
  // ── END STAGE SCROLL BEHAVIOUR ────────────────────────────────────────────

  // ── SAVED COMBINATIONS ───────────────────────────────────────────────────
  const SLOTS_KEY = 'cadar-col-slots';

  function loadSlots() {
    try {
      const raw = localStorage.getItem(SLOTS_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return [parsed[0] || null, parsed[1] || null, parsed[2] || null];
    } catch(e) { return [null, null, null]; }
  }

  function saveSlots(slots) {
    localStorage.setItem(SLOTS_KEY, JSON.stringify(slots));
  }

  function closeAllPopovers() {
    document.querySelectorAll('.col-slot-popover.open').forEach(p => p.classList.remove('open'));
  }

  function makeSliceSVG(slot, uid) {
    const s = 34, n = slot.size === 'small' ? 2 : 3;
    const layers = slot.size === 'small' ? ['top', 'bottom'] : ['top', 'mid', 'bottom'];
    const bandH = s / n;
    const rects = layers.map((layer, i) =>
      `<rect x="0" y="${(i * bandH).toFixed(2)}" width="${s}" height="${bandH.toFixed(2)}" fill="${SWATCH_COLORS[slot[layer]] || '#ccc'}"/>`
    ).join('');
    const sep = layers.slice(1).map((_, i) =>
      `<line x1="0" y1="${((i + 1) * bandH).toFixed(2)}" x2="${s}" y2="${((i + 1) * bandH).toFixed(2)}" stroke="#fff" stroke-width="1"/>`
    ).join('');
    return `<svg width="${s}" height="${s}" viewBox="0 0 ${s} ${s}"><defs><clipPath id="cc${uid}"><circle cx="17" cy="17" r="16"/></clipPath></defs><g clip-path="url(#cc${uid})">${rects}${sep}</g></svg>`;
  }

  function renderSlots() {
    const slots = loadSlots();
    const container = document.getElementById('col-slots');
    if (!container) return;
    container.innerHTML = '';

    slots.forEach((slot, i) => {
      const btn = document.createElement('button');
      btn.className = 'col-slot' + (slot ? ' col-slot--filled' : '');

      if (slot) {
        const svgWrap = document.createElement('div');
        svgWrap.innerHTML = makeSliceSVG(slot, i);
        const sizeLabel = document.createElement('span');
        sizeLabel.className = 'col-slot-sizelabel';
        sizeLabel.textContent = slot.size.charAt(0).toUpperCase();
        btn.appendChild(svgWrap);
        btn.appendChild(sizeLabel);

        const popover = document.createElement('div');
        popover.className = 'col-slot-popover';

        [['Load', false], ['Replace', false], ['Remove', true]].forEach(([label, isDanger]) => {
          const pbtn = document.createElement('button');
          pbtn.className = 'col-slot-popover-btn' + (isDanger ? ' danger' : '');
          pbtn.textContent = label;
          pbtn.addEventListener('click', e => {
            e.stopPropagation();
            const current = loadSlots();
            if (label === 'Load') {
              const saved = current[i];
              state.size   = saved.size;
              state.top    = saved.top;
              state.mid    = saved.mid;
              state.bottom = saved.bottom;
              if (state.size === 'small' && state.position === 'mid') state.position = 'top';
              document.querySelectorAll('.col-pill').forEach(b => b.classList.toggle('active', b.dataset.size === state.size));
              setPosBtnActive(state.position);
              btnMid.disabled = state.size === 'small';
              refresh();
            } else if (label === 'Replace') {
              current[i] = { size: state.size, top: state.top, mid: state.mid, bottom: state.bottom };
              saveSlots(current);
            } else if (label === 'Remove') {
              current[i] = null;
              saveSlots(current);
            }
            closeAllPopovers();
            renderSlots();
          });
          popover.appendChild(pbtn);
        });

        btn.appendChild(popover);
        btn.addEventListener('click', e => {
          e.stopPropagation();
          const isOpen = popover.classList.contains('open');
          closeAllPopovers();
          if (!isOpen) popover.classList.add('open');
        });

      } else {
        const plus = document.createElement('span');
        plus.className = 'col-slot-plus';
        plus.textContent = '+';
        btn.appendChild(plus);
        btn.addEventListener('click', () => {
          const current = loadSlots();
          current[i] = { size: state.size, top: state.top, mid: state.mid, bottom: state.bottom };
          saveSlots(current);
          renderSlots();
        });
      }

      container.appendChild(btn);
    });
  }

  document.addEventListener('click', closeAllPopovers);

  document.getElementById('btn-reset-slots').addEventListener('click', () => {
    if (!confirm('Remove all saved combinations?')) return;
    saveSlots([null, null, null]);
    renderSlots();
  });

  renderSlots();
  renderDrawer();
  // ── END SAVED COMBINATIONS ───────────────────────────────────────────────
})();
